import { Controller } from 'stimulus';

export default class extends Controller {
  static values = { profile: Object };

  connect() {
    if (Object.keys(this.profileValue).length === 0)
      return;

    if (window.intercomSettings && !window.intercomSettings.booted) {
      this.callIntercom('boot', this.profileValue);

      window.intercomSettings.booted = true;
    }

    Intercom('onUnreadCountChange', unreadCount => {
      if (unreadCount > 0) {
        this.callIntercom('showMessages');
      }
    });
  }

  openTour(ev) {
    const { tourId } = ev.target.dataset;

    if (tourId) {
      this.callIntercom('startTour', tourId);
    }
  }

  callIntercom(method, arg) {
    const style = 'color:white; background-color: #0B6458; padding: 0.25em 0.5em';

    console.group(`Intercom %c${method}`, style);

    if (arg) {
      console.table({ ...arg });
    }

    console.groupEnd();

    if (typeof window.Intercom === 'function') {
      try {
        window.Intercom(method, arg);
      } catch(error) {
        console.debug(error.message);
      }
    }
  }
}
